// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"313":"42752947","602":"19f417ca"}[chunkId] + ".chunk.css";
};